import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "./button";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Calendar } from "./calendar";
import { cn, formatDate } from "@/shared/lib/utils";
import { DayPicker } from "react-day-picker";
type DatePickerProps = {
  value?: Date;
  onChange: (Date?: Date) => void;
  size?: "default" | "md" | "sm";
  variant?: "default" | "dob";
} & React.ComponentProps<typeof Popover> & Omit<React.ComponentProps<typeof DayPicker>, "mode" | "selected" | "onSelect">;
export function DatePicker(t0) {
  const $ = _c(29);
  let onChange;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      size: t1,
      variant: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onChange;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = value;
  } else {
    onChange = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    value = $[5];
  }
  const size = t1 === undefined ? "default" : t1;
  const variant = t2 === undefined ? "default" : t2;
  let t3;
  if ($[6] !== variant) {
    t3 = variant === "dob" ? {
      fromYear: new Date().getFullYear() - 100,
      toDate: new Date(),
      captionLayout: "dropdown" as const
    } : {};
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const dobProps = t3;
  const t4 = size === "sm" ? "h-8 text-xs px-2.5" : size === "md" ? "h-10 text-sm px-3" : "h-10";
  const t5 = !value && "text-muted-foreground";
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = cn("w-full justify-between text-left font-normal", "rounded-md border border-border", "bg-inherit text-foreground", "hover:bg-muted", t4, t5);
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== value) {
    t7 = value ? formatDate(value) : <span>Pick a date</span>;
    $[11] = value;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = size === "sm" ? "h-3 w-3" : size === "md" ? "h-3.5 w-3.5" : "h-4 w-4";
  let t9;
  if ($[13] !== t8) {
    t9 = cn("ml-2 shrink-0 text-muted-foreground", t8);
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <CalendarIcon className={t9} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6 || $[19] !== t7) {
    t11 = <PopoverTrigger render={<Button variant="outline" className={t6}>{t7}{t10}</Button>} />;
    $[17] = t10;
    $[18] = t6;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== dobProps || $[22] !== onChange || $[23] !== props || $[24] !== value) {
    t12 = <PopoverContent className="w-auto p-0" align="start"><Calendar mode="single" selected={value} onSelect={onChange} {...dobProps} {...props} className="rounded-md border-none" /></PopoverContent>;
    $[21] = dobProps;
    $[22] = onChange;
    $[23] = props;
    $[24] = value;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <Popover>{t11}{t12}</Popover>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}